module.exports = __webpack_public_path__ + "static/media/snow.36aa850c.svg";